import client, { storeAccessToken } from './client';

export const login = async (credentials) => {
  const response = await client.post('/auth/login', credentials);
  const data = response.data || {};
  const token = data?.token?.accessToken || data?.token?.access_token;
  if (token) {
    storeAccessToken(token);
  }
  return data;
};

export const fetchProfile = async () => {
  const response = await client.get('/auth/me');
  return response.data;
};

export const logout = () => {
  storeAccessToken(null);
};
